// extracted by mini-css-extract-plugin
module.exports = {"section":"styles_section__UeWlc","titleStyle":"styles_titleStyle__P0Sot","container":"styles_container__54PAj","swiperWrapper":"styles_swiperWrapper__J00if"};